import type { IFollowRepository } from '../repositories/IFollowRepository.js';

interface Deps { followRepository: IFollowRepository; }

export function createListFollowingIdsUseCase({ followRepository }: Deps) {
  return function listFollowingIds(userId: string): Promise<string[]> {
    return followRepository.listFollowingIds(userId);
  };
}

export function createListFollowerIdsUseCase({ followRepository }: Deps) {
  return function listFollowerIds(userId: string): Promise<string[]> {
    return followRepository.listFollowerIds(userId);
  };
}

export function createFollowUserUseCase({ followRepository }: Deps) {
  return function followUser(followerId: string, followingId: string): Promise<void> {
    return followRepository.follow(followerId, followingId);
  };
}

export function createUnfollowUserUseCase({ followRepository }: Deps) {
  return function unfollowUser(followerId: string, followingId: string): Promise<void> {
    return followRepository.unfollow(followerId, followingId);
  };
}
